import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    alias: '/',
    path: '/register/:plan?',
    name: 'Home',
    component: () => import('../views/authentication/Register.vue'),
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import('../views/Checkout.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/newsroom',
    name: 'Newsroom',
    component: () => import('../views/Newsroom.vue')
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: () => import('../views/Pricing.vue')
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import('../views/authentication/Success.vue')
  },
  {
    path: '/confirmed-account/:email_validation_code?',
    name: 'Confirmed Account',
    component: () => import('../views/authentication/ConfirmedAccount.vue'),
    beforeEnter: (to, from, next) => {
      if (!to.params.email_validation_code) next('/register');
      else next();
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  routes
})

export default router
